module.exports = __webpack_public_path__ + "images/crowd-pleaser-b1d195d71548f54bdf377f73282e0a9b.png";